import { useEffect } from 'react';

/** Sets `document.title` to "<title> · Forestum" for as long as the component is mounted. */
export function usePageTitle(title: string) {
  useEffect(() => {
    document.title = `${title} · Forestum`;
  }, [title]);
}
